import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7 2C4.23858 2 2 4.23858 2 7C2 7.91238 2.24346 8.76486 2.6683 9.49927C2.94484 9.97733 2.78148 10.5891 2.30342 10.8656C1.82536 11.1421 1.21363 10.9788 0.937087 10.5007C0.340903 9.4701 0 8.27334 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 8.27334 13.6591 9.4701 13.0629 10.5007C12.7864 10.9788 12.1746 11.1421 11.6966 10.8656C11.2185 10.5891 11.0552 9.97733 11.3317 9.49927C11.7565 8.76486 12 7.91238 12 7C12 4.23858 9.76142 2 7 2ZM9.75 6.75C9.75 8.26878 8.51878 9.5 7 9.5C5.48122 9.5 4.25 8.26878 4.25 6.75C4.25 5.23122 5.48122 4 7 4C8.51878 4 9.75 5.23122 9.75 6.75ZM2.47699 13.3661C3.27765 11.6721 5.00196 10.5001 7 10.5001C8.99803 10.5001 10.7223 11.6721 11.523 13.3661C11.6673 13.6713 11.4275 14 11.0899 14H2.91008C2.57245 14 2.33271 13.6713 2.47699 13.3661Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }